import { ITileMapShip } from './tileMapShip'
import { tileMapShip } from './tileMapShip-sidecar'
import { tilesDataShip } from './tilesDataShip-sidecar'
import { tilesShip } from './tilesShip-sidecar'
import { asteroids } from '../entities/asteroids-sidecar'
import { l } from '../lib/imports'
import { IAsteroidType } from '../entities/asteroidsData'

const wipeloc = 15
export function wipeRight(map: ITileMapShip) {
  for (let j = 0; j < map.height; j++) {
    for (let i = wipeloc; i < map.width; i++) {
      let t = tileMapShip.getTileUnsafe(map, i, j)
      tilesShip.setFloor(t, null)
      tilesShip.setShadow(t, null)
      tilesShip.setStructure(t, tilesDataShip.getByIndex(1))
    }
  }

  let as = asteroids.getAll()
  l.forEach(as, (c) => {
    if (c.i > wipeloc) {
      asteroids.kill(c)
    }
  })
}

export function addAsteroids(map: ITileMapShip) {
  let num = l.random(3, 20)

  let types = ['ice', 'rock', 'rock']

  for (let i = 0; i < num; i++) {
    let x = l.random(wipeloc + 1, map.width - 1)
    let y = l.random(0, map.height - 1)

    if (tileMapShip.inRange(map, x, y)) {
      if (!asteroids.findAtSpot(x, y, (c) => true)) {
        let as = asteroids.create(l.sample(types) as IAsteroidType)
        asteroids.moveToTile(as, map, x, y)
      }
    }
  }
}

export function addWreck(map: ITileMapShip) {
  let num = l.random(1, 20)

  let types = ['ice', 'rock', 'rock']

  let m = 4
  let h = 3
  let x = l.random(wipeloc + m, map.width - 1 - m)
  let y = l.random(0 + m, map.height - 1 - m)

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < m; i++) {
      let t = tileMapShip.getTile(map, x + i, y + j)
      if (t) {
        if (i === 2) {
          tilesShip.setFloor(t, tilesDataShip.getByIndex(4))
        } else {
          tilesShip.setFloor(t, tilesDataShip.getByIndex(3))
        }
      }
    }
  }
}
